<template>
    <div style="border:1px solid #e8eaec;border-bottom:none;" id="rawcart">
        <div>
            <Table row-key="id" :columns="table_header" :border="false" :data="table_data" show-summary :summary-method="handleSummary" height="200">
                <template slot-scope="{ row }" slot="title">
                    <!--   <strong>{{getCustomRow(row.id)}}</strong>
                    <br> -->
                    <span>{{ row.title }}</span>
                </template>
                <template slot-scope="{ row }" slot="orderNumber">
                    <!-- <div v-if="row.pkgclass===3||row.pkgclass===2">
                        <InputNumber style="width:50%;" size="large" :max="100" :min="row.pkgclass===3?1:1" v-model="row.orderNumber" @on-change="numberChanged(row)"></InputNumber>
                    </div> -->
                    <div>
                        {{row.orderNumber}}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="remainingday">
                    <div v-if="row.pkgclass===0">
                        <Select :disabled="true" v-model="purchaseYears" style="width:100px" @on-change="yearsChange($event,row)">
                            <Option v-for="item in yearsData" :value="item.value" :label="item.title" :key="item.id">
                                <span>{{item.title}}</span>
                                <span style="float:right;color:#ccc">{{item.desc}}</span>
                            </Option>
                        </Select>
                    </div>
                    <div v-else><span>{{ row.remainingday }}天</span></div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <!-- <Button type="primary" size="small" style="margin-right: 5px" @click="show(id)">详情</Button> -->
                    <Button type="error" size="small" @click="remove(row.id)">删除</Button>
                </template>
            </Table>
        </div>
        <!-- 优惠信息 -->
        <div style="height: 265px;overflow-y: auto;">
            <Divider orientation="right">优惠信息</Divider>
            <!--  会员优惠 -->
            <div v-if="payType===1" style="width: 500px;margin-left:auto;text-align: left;">
                <Card :bordered="false" dis-hover>
                    <CellGroup>
                        <Cell v-for="item in yearsOffItems" :title="item.discountname+','+item.discountdesc" :key="item.discountcode">
                            <Icon v-if="item.selected" type="md-checkmark-circle" color="#19be6b" size="22" slot="extra" />
                            <span v-else slot="extra">未满足</span>
                        </Cell>
                    </CellGroup>
                </Card>
            </div>
            <!--  升级包优惠 -->
            <div v-else style="width: 500px;margin-left:auto;text-align: left;">
                <Card :bordered="false" dis-hover>
                    <CellGroup>
                        <Cell v-for="item in couponItems" :title="item.discountdesc" :key="item.id">
                            <Icon v-if="item.selected" type="md-checkmark-circle" color="#19be6b" size="22" slot="extra" />
                            <span v-else slot="extra">未满足</span>
                        </Cell>
                    </CellGroup>
                </Card>
            </div>
            <div style="text-align:right;padding-right: 30px;">
                <Coupon ref="mycoupon" @on-check="onCouponChecked" :isCouponShow=true />
            </div>
            <!-- <div style="margin-right:30px;text-align: right;">
                <span>优惠券：</span>
                <Input v-model="couponValue" placeholder="请输入优惠券并点击确认" style="width: 200px" />&nbsp;
                <Button type="text" style=";box-shadow:none;text-decoration:underline;color:#19be6b;">确认</Button>
            </div>
            <div style="margin-right:30px;text-align: right;margin-top:5px;">
                <span>运营商编码：</span>
                <Input v-model="agencies" placeholder="请输入运营商编码并点击确认" style="width: 200px" />&nbsp;
                <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;">确认</Button>
            </div> -->
        </div>
        <!-- 支付信息 -->
        <Divider orientation="right">支付信息</Divider>
        <div style="color:red;font-size: 18px;text-align: right;margin-right: 30px;">
            <!-- <span style="text-decoration: line-through;color:#c5c8ce;font-size: 14px;padding-right: 20px;">原价:{{totalPrice}}元</span>  -->
            <span>实际支付:{{payPrice}}元</span>
        </div>
        <div class="pay-change" style="text-align: right;margin-right: 20px;margin-top:10px;">
            <span>选择支付方式：</span>
            <RadioGroup v-model="payChange">
                <Radio label="微信" border>
                    <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                    <span style="color: #19c105;">微信</span>
                </Radio>
                <!-- <Radio label="支付宝" border>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝</span>
                </Radio> -->
            </RadioGroup>
        </div>
        <div class="invoiceContent">
            <span>发票信息：</span>
            <span v-if="invoiceType===1">普通发票</span>
            <span v-else-if="invoiceType===2">增值税专用发票</span>
            <span>{{invoiceHeaderName}}</span>
            <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
        </div>
        <Modal v-model="modalInvoice" width="700" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref='myInvoice' :isModal="true"  />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">确认</Button>
            </div>
        </Modal>
        <!-- <div class="agreement-content">
            <Checkbox style="margin-right: 0px;" v-model="agreementChecked" @on-change="popAgreement">我已认真阅读协议</Checkbox>《<span class="agreement-user">用户协议</span>》
        </div> -->
    </div>
</template>
<script>
import moment from 'moment'
import invoice from './myinvoice.vue'
import coupon from './coupon.vue'
export default {
    name: 'shopping_cart',
    // props:{
    //  tData:Array,
    // },
    data() {
        return {
            copydata: '',
            memberLevelChkInfo: null,
            promocode: {
                couponcode: '',
                agentcode: '',
            },
            sonheadertype:1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",

            },
            invoiceType: 1,
            invoiceHeaderName: '个人',
            modalInvoice: false,
            purchaseYears: 1,
            agencies: '',
            couponValue: '',
            payChange: '微信',
            agreementChecked: true,
            table_header: [{
                    title: '序号',
                    type: 'index',
                    key: 'id',
                    width: 120,
                },
                {

                    title: '产品名称',
                    slot: 'title',
                    tree: true
                },
                // {
                //     title: '产品描述',
                //     key: 'desc'
                // },
                {

                    title: '购买数量',
                    slot: 'orderNumber',
                },
                {

                    title: '购买时长',
                    slot: 'remainingday',
                },
                {
                    title: '产品价格',
                    key: 'total',
                    render: (h, params) => {
                        const row = params.row
                        const text = Number(row.total).toFixed(2)
                        //return h('span', text + " 元");
                        return h('span', [
                            h('span', {
                                domProps: {
                                    innerHTML: `<span>` + text + `</span> 元`,
                                }
                            }), ''
                        ])
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center'
                }
            ],
            table_data: [],
            totalPrice: 0,
            payPrice: 0,
            couponItems: [],
            // couponItems: [{
            //     id: '8001',
            //     title: '购买任意两类VIP升级包享9折优惠',
            //     discount: 0.9,
            //     isCheck: false,
            // }, {
            //     id: '8002',
            //     title: '购买任意三类VIP升级包享8.5折优惠',
            //     discount: 0.85,
            //     isCheck: false,
            // }, {
            //     id: '8003',
            //     title: '购买任意四类VIP升级包享8折优惠',
            //     discount: 0.80,
            //     isCheck: false,
            // }],
            coupon: null,
            yearsData: [{
                id: '30001',
                title: '一年',
                value: 1,
                desc: '原价'
            }, {
                id: '30002',
                title: '二年',
                value: 2,
                desc: '优惠',
            }, {
                id: '30003',
                title: '三年',
                value: 3,
                desc: '优惠',
            }],
            yearsOffItems: [
                // {
                //     discountcode:"000001",
                //     discountdesc: "一年原价出售",
                //     discountname: "一年/365元",
                //     newprice: 0.01,
                //     oriprice: 365,
                //     salenumber: 1,
                //     selected: true
                // }
            ],
            // yearsOffItems: [{
            //     id: '9001',
            //     title: '全国版种子用户会员购满二年享9.5折优惠',
            //     discount: 0.95,
            //     isCheck: false,
            // }, {
            //     id: '9002',
            //     title: '全国版种子用户会员购满三年享9折优惠',
            //     discount: 0.9,
            //     isCheck: false,
            // }],
            yearsItem: null, //所有择的按年数优惠项
            payType: 1, //1=会员,2=升级包
        }
    },
    components: {
        'Invoice': invoice,
        'Coupon': coupon
    },
    computed: {
        // payPrice: function() {
        //     let p = 0
        //     if (this.payType === 1) {
        //         p = (this.totalPrice * (this.yearsItem ? this.yearsItem.discount : 1)).toFixed(2)
        //     } else {
        //         p = (this.totalPrice * (this.coupon ? this.coupon.discount : 1)).toFixed(2)
        //     }

        //     return p
        // },
    },
    methods: {
        showCouponPrice(value) {
            this.payPrice = value.item.amount
            //this.orderamount=value.item.oriamount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.payPrice, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()

                //还原到原始价格
                let _copy = JSON.parse(this.copydata)
                this.payPrice = _copy.oriprice

                //this.loadDefaultPackages(this.userleveldata)
            }
        },
        showInvoice() {
            this.modalInvoice = true
            this.$refs.myInvoice.invoicetype = '1'
            this.$refs.myInvoice.invoiceTotal=this.payPrice
            //this.$refs.myInvoice.getInvoice()
        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        getInvoiceInfo() {
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if(this.$refs.myInvoice.formData.headertype == 1){
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    //this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    // console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        // getInvoiceInfo() {
        //     let _invoiceType = this.$refs.myInvoice.invoicetype
        //     let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //     console.log(invoiceHeader)
        //     this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //     this.invoiceType = Number(_invoiceType)
        //     this.myInvoiceHeader = invoiceHeader
        //     this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //     this.modalInvoice = false

        //     console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        // },
        yearsChange(value, row) {
            console.log(value)
            console.log(row)
            let ro = this.table_data.find(p => p.name === row.name)
            let totalprice = (ro.price * row.number * value * 365).toFixed(2)
            ro.total = totalprice
            ro.remainingday = 365 * value
            ro.expirationDate = moment().add(ro.remainingday, 'days').format("YYYY-MM-DD");
            let c = this.table_header
            let d = this.table_data
            let da = {
                columns: c,
                data: d
            }
            console.log(this.table_data)
            this.handleSummary(da)
            this.yearsAutoDiscount()
        },
        popAgreement(value) {
            this.$emit('agreement', value)
            console.log(this.agreementChecked)
        },
        numberChanged(row) {
            console.log(row)
            let ro = this.table_data.find(p => p.name === row.name)
            let totalprice = (ro.price * row.orderNumber * row.remainingday).toFixed(2)
            ro.total = totalprice
            ro.orderNumber = row.orderNumber
            ro.remainingday = row.remainingday
            let c = this.table_header
            let d = this.table_data
            let da = {
                columns: c,
                data: d
            }
            console.log(this.table_data)
            this.handleSummary(da)
        },
        getCustomRow(type) {
            let desc = ''
            if (type === '000009') {
                desc = '升级一键上传'
            }
            if (type === '000010') {
                desc = '升级文件下载'
            }
            if (type === '000011') {
                desc = '升级分屏权限'
            }
            if (type === '000012') {
                desc = '升级文件仓库'
            }
            //会员包id=000001
            if (type === '000001') {
                desc = '账号等级包'
            }
            return desc
        },
        show(data) {
            //console.log(22222222222222)
            console.log(data)
            this.table_data = this.buildTableData(data)
            //console.log(this.table_data)
            var that = this
            if (this.table_data.length > 0 && this.table_data[0].pkgclass === 0) {
                this.payType = 1
                this.yearsAutoDiscount1(data.productdiscount)
                //订单总额和实付金额
                console.log(data)
                let list = []
                list = data.productdiscount
                if (list) {
                    list.forEach(function(item) {
                        if (item.discountcode === "000001") {
                            that.totalPrice = item.oriprice
                            that.payPrice = item.newprice
                        }
                    })
                }
                console.log(this.table_data)

            } else {
                this.payType = 2
                console.log(data.pkgdiscount)
                this.totalPrice = data.pkgdiscount.orderamount
                this.payPrice = data.pkgdiscount.actualamount
                this.couponItems = data.pkgdiscount.discountdescdetail
                //this.autoCoupon()
            }

            //拷贝原始价格
            let _copy = {
                oriprice: this.payPrice
            }
            this.copydata = JSON.stringify(_copy)

            //判断是否使用优惠码
            if (this.memberLevelChkInfo && this.memberLevelChkInfo.isChecked) {
                //console.log(333333333333333)
                this.onCouponChecked(this.memberLevelChkInfo)
            } else {
                //清空coupon
                this.$refs.mycoupon.clean()

            }

             //读取发票信息
             this.$refs.myInvoice.getInvoice()
             //this.$refs.myInvoice.invoiceTotal=this.payPrice

            //更新发票信息
            // var that = this
            // this.$refs.myInvoice.getInvoice().then(function(resp) {
            //     console.log('读取发票信息完成...')
            //     that.getInvoiceInfo()
            // })


            // var _that = this
            // this.$refs.myInvoice.getInvoice().then(function(resp) {
            //     console.log(resp)
            //     console.log('读取发票信息完成...')
            //     if (resp.rltcode === 1 && resp.rtncode === 1) {
            //         _that.getInvoiceInfo()
            //     } else {
            //         //设置初次默认
            //         _that.$refs.myInvoice.formData.headertype = "1"
            //         _that.$refs.myInvoice.formData.headername = '个人'
            //         //_that.getInvoiceInfo()
            //     }

            // })


        },
        couponClean() {
            //清空coupon
            this.$refs.mycoupon.clean()
        },
        clearCart() {
            console.log('clear cart....')
            this.table_data = []
        },
        autoCoupon() {
            //查询可以享受的优惠
            let defaultCoupon = {
                id: '8000',
                title: '无优惠',
                discount: 1,
                isCheck: false,
            }
            this.couponItems.forEach(function(item) {
                item.isCheck = false
            })
            // let ar = this.table_data.filter(p => p.class > 0)
            // console.log(ar)
            // let r = Array.from(ar, (x) => x.class) //过滤class
            // r = Array.from(new Set(r)) //去重
            // console.log(r)
            let r = this.table_data
            if (r.length === 0 || r.length === 1) {
                this.coupon = defaultCoupon
            }
            if (r.length === 2) {
                this.coupon = this.couponItems.find(p => p.id === '8001')
                this.coupon.isCheck = true
            }
            if (r.length === 3) {
                this.coupon = this.couponItems.find(p => p.id === '8002')
                this.coupon.isCheck = true
            }
            if (r.length === 4) {
                this.coupon = this.couponItems.find(p => p.id === '8003')
                this.coupon.isCheck = true
            }
            console.log(this.coupon)

        },
        yearsAutoDiscount1(items) {
            //传入时已选中一年的优惠
            this.yearsOffItems = items
        },
        yearsAutoDiscount() {
            let defaultCoupon = {
                id: '9000',
                title: '无优惠',
                discount: 1,
                isCheck: false,
            }
            this.yearsOffItems.forEach(function(item) {
                item.isCheck = false
            })
            let ar = this.table_data.filter(p => p.class === 0)
            if (this.purchaseYears === 1) {
                this.yearsItem = defaultCoupon
            }
            if (this.purchaseYears === 2) {
                this.yearsItem = this.yearsOffItems.find(p => p.id === '9001')
                this.yearsItem.isCheck = true
            }
            if (this.purchaseYears === 3) {
                this.yearsItem = this.yearsOffItems.find(p => p.id === '9002')
                this.yearsItem.isCheck = true
            }
            console.log(ar)
        },
        buildTableData(data) {
            let da = [];
            da = data
            return da;
        },
        remove(id) {
            this.$emit('remove', id)
            console.log(this.table_data.length)
            if (this.table_data.length === 0) {
                this.payPrice = 0
            }

            //拷贝原始价格
            let _copy = {
                oriprice: this.payPrice
            }
            this.copydata = JSON.stringify(_copy)

            //console.log(this.table_data)
        },
        handleSummary({ columns, data }) {
            console.log('handleSummary===>')
            const sums = {};
            const count_sum = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    //console.log(sums[key])
                    sums[key] = {
                        key,
                        value: '共计：'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    count_sum[key] = {
                        key,
                        value: v
                    }
                    sums[key] = {
                        key,
                        value: v.toFixed(2) + ' 元',
                    };
                } else {
                    sums[key] = {
                        key,
                        value: ''
                    };
                }
            });
            //this.totalPrice = count_sum.total.value.toFixed(2)
            //this.$emit('popTotal', count_sum.total)
            console.log(sums)
            return sums;
        },

    },
    created() {},
    mounted() {
        // console.log('mounted cart===>')
        // this.show(this.tdata)
    }
}
</script>
<style lang="less" scoped>
#rawcart/deep/.ivu-table-summary {
    color: #ed4014;
    font-size: 16px;
    // font-weight: bold;

}

.agreement-content {
    margin-top: 10px;
    margin-right: 20px;
    font-size: 10px;
    text-align: right;
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}

@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}

.pay-change {
    text-align: center;
}

/*发票信息*/
.invoiceContent {
    margin-top: 10px;
    text-align: right;
    padding-right: 15px;

    span {
        padding-left: 10px;
    }
}
</style>